import { tt } from '../services/turbo';

/**
 * ⚡ Turbo-Kopf für „Vinted erfassen" / „DHL erfassen": letztes Paket mit großem Fach, Zähler, Durchschnittszeit.
 * letzter = { fach, name, kurz, ausnahme? } | null — ausnahme ist ein Text-Schlüssel aus services/turbo.js
 * wartend = schon gescannt, Name/Buchung läuft noch (22.10.2026: ohne Anzeige wirkte ein Scan „nicht erfasst", bis der Name kam)
 */
export default function TurboAnzeige({ language, letzter, gebucht, ausnahmen, schnittMs, dark, wartend = 0 }) {
  const T = tt(language);
  const rot = !!(letzter && letzter.ausnahme);
  const grund = rot ? T(letzter.ausnahme) : '';
  return (
    <div data-testid="turbo-anzeige" data-ausnahme={rot ? '1' : '0'} style={{
      marginTop: 10, padding: '12px 14px', borderRadius: 12, textAlign: 'center',
      background: rot ? '#c62828' : (dark ? '#1b3a2a' : '#e8f5e9'), color: rot ? '#fff' : (dark ? '#c8e6c9' : '#1b5e20'),
      border: `2px solid ${rot ? '#8e0000' : '#2e7d32'}`,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 700, opacity: 0.9 }}>
        <span>{T('badge')}{wartend > 0 ? <b data-testid="turbo-wartend" style={{ marginLeft: 8, padding: '1px 8px', borderRadius: 10, background: dark ? '#37474f' : '#fff8e1', color: dark ? '#ffe082' : '#8d6e00' }}>⏳ {wartend}</b> : null}</span>
        <span>{T('gebucht', { n: gebucht })}{ausnahmen ? ` · ${T('ausnahmen', { n: ausnahmen })}` : ''}{schnittMs ? ` · ${T('schnitt', { s: (schnittMs / 1000).toFixed(1) })}` : ''}</span>
      </div>
      {!letzter && <div style={{ fontSize: 18, fontWeight: 600, padding: '14px 0' }}>{T('bereit')}</div>}
      {letzter && (
        <>
          <div data-testid="turbo-fach" style={{ fontSize: 72, fontWeight: 800, lineHeight: 1.05, marginTop: 4, letterSpacing: 1 }}>{letzter.fach || '—'}</div>
          <div style={{ fontSize: 18, fontWeight: 600, marginTop: 2, wordBreak: 'break-word' }}>{letzter.name || ''}{letzter.kurz ? <span style={{ opacity: 0.75, fontWeight: 400 }}> · {letzter.kurz}</span> : null}</div>
          {rot && <div data-testid="turbo-grund" style={{ fontSize: 15, fontWeight: 700, marginTop: 6 }}>⚠️ {grund}</div>}
        </>
      )}
    </div>
  );
}
